export default __webpack_public_path__ + "static/media/delegates__cards-list-item-icon-2.bb0e3289.svg";